import styled from "styled-components";

export const DataTile = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export default DataTile;